module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAMCAYAAABSgIzaAAAAAXNSR0IArs4c6QAAANZJREFUKFOdkLEuBGEUhb9zCVtpNLTCC+jXO+hE5TG2kf+OKfTKLSQqnafwBnrRbrOFREHMHP6NKETMxO2/e875xMjLzDvgGNjOzKVGcrRte9B13T3wCEyVmYfAVkR0A0+Wto9sXwHzCr4AG4CH0m0/SdoHpFLKWUTsAu9DIBC2XyUtRm/8+fT/YGaeADuSNoF+RN1124sqZyXF9gOwJ6mK+utqy7cqZwbMJN1ExDUw+bL8K9z3/RrwvNrYNM257QtJWUppRtTlW05N/tx5Kem0lHI7BH8AreNJCnHrb9sAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/login/change-icon.png
// module id = X8YI
// module chunks = 95